<div class="card card-profile ">
  <div class="profile">
    <div class="info">
      <div class="info-row">
        <div class="info-item">
          <div class="icon-container">
            <span class="figure" [hidden]="pendingDocumentsQuantity == null || isDocumentsLoading">
              {{ pendingDocumentsQuantity }}
            </span>

            <i class="icon ic-form-pending-20 bg-orange"></i>
          </div>

          <div class="text">Pending Forms</div>
        </div>

        <div class="info-item">
          <div class="icon-container">
            <span class="figure">100%</span>
            <i class="icon ic-notes-20"></i>
          </div>

          <div class="text">Readines</div>
        </div>
      </div>
    </div>

    @if (showXpm) {
      <app-divider></app-divider>

      <div class="company-action-list">
        <app-xpm-card-profile
          [(externalEntities)]="trustProfile.externalEntities"
          [entityId]="trustProfile.entityId"
          [entityNumber]="trustProfile.entityNumber"
          [disableControls]="disableControls"
          (onEntityRefreshed)="onTrustRefreshedEvent()"
          [entityType]="entityType"
        />
      </div>
    }

  </div>
</div>
